<template>
  <div class="vue">
    <!-- <common-check /> -->
    <div class="container error padded60" v-if="error != null">
      <span v-if="error.statusText != null">
        {{error.statusText}}
      </span>
      <span v-else>
        {{error}}
      </span>
    </div>
    <div v-if="error==null && activeSensor">
      <div class="container large userPanel">
        <div class="row">
          <div class="col s12 m12 l8 userWelcome">
            <p><strong>{{ $t('project.welcome') }}</strong></p>
            <label class="stats-label">{{ $t('project.stat', { label: activeSensor && activeSensor.label}) }}</label>
            <stats :url="statsSensorUrl" customClass="fixed"/>
          </div>
          <div class="col s12 m12 l4" id="notifications">
            <!-- <label>Notifications</label> -->
          </div>
        </div>
      </div>
      <div class="container overflow tabbed">
        <ul class="tabs">
          <li v-cloak v-for="(sensor, index) in sensors" :key="'sensor' + index" class="tab">
            <a class="hyperlink" v-bind:class="{ active: (activeSensor.id == sensor.id && activeTab == 'table'), [activeSensor.id]: true}" @click="updateSensor(sensor)">
              <span :class="{'ion-ios-mic': sensor.id =='ARU',
              'ion-ios-camera': sensor.id == 'CAM', 'ion-android-locate': sensor.id == 'PC'}"></span>
              <!--<span v-else class="ion-android-radio-button-off bullseye-outer"><span class="ion-android-radio-button-off bullseye-inner"></span><span class="ion-record bullseye-innermost"></span></span>-->
              {{sensor && sensor.label}}
            </a>
          </li>
          <!-- <li class="indicator" style="right: 1393px; left: 0px;"></li>         -->
          <!--li class="tab right"><a @click="activeTab='user'"><span class="ion-person"></span> Users</a></li-->
          <!-- <li class="tab right"><a v-bind:class="{ active: (activeTab == 'equipment')}" @click="activeTab='equipment'"><span class="ion-ios-download-outline"></span>Equipment</a></li>   -->
        </ul>
        <project-table ref="project" v-bind:sensor="activeSensor" v-if="activeTab == 'table' && activeSensor != null"
        v-bind:show-admin-only-projects="false"/>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>

<script>
/* this component show two tabs + stats + notification for all projects
under each project tab, show a table listing all projects. users can also update project properties + users
or remove projects if they have no associated data.
*/
import Vue from 'vue';
import ProjectTable from './ProjectTable';
import StatsBox from '@/components/common/StatsBox';
import {API_URL, getParameterByName, attachAuthorizaitonHeader} from '@/lib/common';

// import VueJsModal from 'vue-js-modal';
// Vue.use(VueJsModal, {
//   dialog: true,
//   dynamic: true
// });
import VueJsModal from 'vue-js-modal'
Vue.use(VueJsModal, {
  dialog: true,
  dynamic: true,
  dynamicDefaults: {
    foo: 'foo'
  }
});

export default {
  name: 'project-page',
  components: {'project-table': ProjectTable, 'stats': StatsBox},
  computed: {
    statsSensorUrl: function () {
      return this.statsUrl + '?sensorId=' + this.activeSensor.id;
    }
  },
  methods: {
    // a computed getter
    updateSensor: function (sensor) {
      // `this` points to the vm instance
      this.activeSensor = sensor;
      // if (this.$refs['project']) {
      //   this.$refs['project'].url = API_URL + 'get-project-summary?sensorId=' + name; // use this.url won't update the url. lag behind. so I set his way again
      // }
      this.activeTab = 'table';
    },
    createProject: function () {
      this.$refs.project.createProject();
    },
    switchProjectView () {
      this.showMine = !this.showMine;
    }
  },
  created () {
    attachAuthorizaitonHeader();
    this.$http.get(API_URL + 'sensor-options').then(
      function (response) {
        if (response.data.hasOwnProperty.call('error')) {
          this.error = response.data.error;
        }
        this.sensors = response.data;
        if (this.sensors != null) {
          this.activeSensor = this.sensors.find(sensor => sensor.id === getParameterByName('sensorId', 'ARU'));
          this.isManagerOfAnyProject = false;
          this.sensors.forEach(x => { this.isManagerOfAnyProject = this.isManagerOfAnyProject || x.isManagerOfAnyProject; });
        }
      }, response => {
        // error callback
        this.error = 'Error: ' + (response.data ? response.data.error : '') + ' ' + response.status;
      }
    );
  },
  data () {
    return {
      url: API_URL + 'get-project-summary',
      statsUrl: API_URL + 'get-task-user-stats',
      stats: [
        {action: 'ided', count: '12', type: 'species'},
        {action: 'completed', count: '112', type: 'tasks'}
      ],
      sensors: [],
      isManagerOfAnyProject: false, /** local admin for at least one project */
      activeSensor: null, /* default ARU sensor */
      projectListUrl: API_URL + 'get-sensor-summary?projectType=all',
      error: null,
      activeTab: 'table'
    }
  }
}
</script>
<style>
.hyperlink {
  cursor: pointer;
}
.stats-label {
  color: #C94412;
  font-weight: 600;
}
.tabs li.tab {
  margin-left: 2px;
}

.bullseye-outer{
  display: inline-block;
  font-size: 28px !important;
}

.bullseye-inner{
  position: absolute !important;
  top: -1px !important;
  font-size: 16px !important;
  left: 5px;
}

.bullseye-innermost{
  position: absolute !important;
  top: 0px !important;
  font-size: 6px !important;
  left: 9px;
}

.tabs li.tab a.active {
      background: #ffffff;
  }

</style>
